<form class="filter" #formElement [formGroup]="form">
    <mat-form-field class="medium-width margin-right-small">
        <input matInput autocomplete="off" formControlName="from" [matDatepicker]="pickerFrom" placeholder="Fecha desde" required />
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
        <mat-error *ngIf="f.from.errors && f.from.errors.required">
            Ingrese la fecha desde
        </mat-error>
    </mat-form-field>
    <mat-form-field class="medium-width">
        <input matInput autocomplete="off" formControlName="to" [matDatepicker]="pickerTo" placeholder="Fecha hasta" required />
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
        <mat-error *ngIf="f.to.errors && f.to.errors.required">
            Ingrese la fecha hasta
        </mat-error>
    </mat-form-field>

    <mat-form-field class="medium-width margin-right-small">
        <mat-select placeholder="Entidades" formControlName="entities" multiple>
            <mat-select-trigger>
                {{ f.entities.value?.length > 0 ? f.entities.value[0].Name : "" }}
                <span *ngIf="f.entities.value?.length > 1" class="additional-selection">
          (+{{ f.entities.value.length - 1 }}
          {{ f.entities.value?.length === 2 ? "otra" : "otras" }})
        </span>
            </mat-select-trigger>
            <mat-option #allEntitySelected (click)="toggleAllEntitySelection()" [value]="{ Id: 0, Name: 'Todas' }">Todas</mat-option>
            <mat-option *ngFor="let entitie of entities" [value]="entitie">
                {{ entitie.Name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <mat-select placeholder="Planes" formControlName="plans" multiple>
            <mat-select-trigger>
                {{ f.entities.value?.length > 0 ? f.entities.value[0].Name : "" }}
                <span *ngIf="f.plans.value?.length > 1" class="additional-selection">
          (+{{ f.plans.value.length - 1 }}
          {{ f.plans.value?.length === 2 ? "otro" : "otros" }})
        </span>
            </mat-select-trigger>
            <mat-option *ngFor="let plan of plans" [value]="plan">
                {{ plan.Name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="medium-width margin-right-small">
        <mat-select placeholder="Alícuotas" formControlName="aliquotTaxs" multiple>
            <mat-select-trigger>
                {{ f.aliquotTaxs.value?.length > 0 ? f.aliquotTaxs.value[0].Name : "" }}
                <span *ngIf="f.aliquotTaxs.value?.length > 1" class="additional-selection">
          (+{{ f.aliquotTaxs.value.length - 1 }}
          {{ f.aliquotTaxs.value?.length === 2 ? "otro" : "otros" }})
        </span>
            </mat-select-trigger>
            <mat-option *ngFor="let aliquotTax of aliquotTaxs" [value]="aliquotTax">
                {{ aliquotTax.Name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <mat-select placeholder="Servicios" formControlName="services" multiple>
            <mat-select-trigger>
                {{ f.services.value?.length > 0 ? f.services.value[0].Name : "" }}
                <span *ngIf="f.services.value?.length > 1" class="additional-selection">
          (+{{ f.services.value.length - 1 }}
          {{ f.services.value?.length === 2 ? "otro" : "otros" }})
        </span>
            </mat-select-trigger>
            <mat-option *ngFor="let service of services" [value]="service">
                {{ service.Name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="medium-width margin-right-small">
        <mat-select placeholder="Equipo" formControlName="equipments">
            <mat-option [value]="null">Todos</mat-option>
            <mat-option *ngFor="let equipment of equipments" [value]="equipment">
                {{ equipment.Name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <mat-select placeholder="Especialidad" formControlName="speciality">
            <mat-option [value]="null">Todas</mat-option>
            <mat-option *ngFor="let speciality of specialities" [value]="speciality">
                {{ speciality.Name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="medium-width margin-right-small">
        <input type="text" matInput placeholder="Práctica" formControlName="practice" [matAutocomplete]="autPractice" />
        <mat-autocomplete #autPractice="matAutocomplete" [displayWith]="filterCompletePractices.displayFn">
            <mat-option *ngFor="let practice of filteredPracticesOptions | async" [value]="practice">
                {{ practice.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>



    <mat-form-field class="medium-width margin-right-small">
        <mat-select placeholder="Estados" formControlName="billingStates" multiple>
            <mat-select-trigger>
                {{ f.billingStates.value?.length > 0 ? f.billingStates.value[0].Name : "" }}
                <span *ngIf="f.billingStates.value?.length > 1" class="additional-selection">
          (+{{ f.billingStates.value.length - 1 }}
          {{ f.billingStates.value?.length === 2 ? "otro" : "otros" }})
        </span>
            </mat-select-trigger>
            <mat-option *ngFor="let billingState of billingStates" [value]="billingState">
                {{ billingState.Name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="medium-width margin-right-small">
        <mat-select placeholder="Motivo no facturar" formControlName="noBillingReasons" multiple>
            <mat-select-trigger>
                {{ f.noBillingReasons.value?.length > 0 ? f.noBillingReasons.value[0].Name : "" }}
                <span *ngIf="f.noBillingReasons.value?.length > 1" class="additional-selection">
          (+{{ f.noBillingReasons.value.length - 1 }}
          {{ f.noBillingReasons.value?.length === 2 ? "otro" : "otros" }})
        </span>
            </mat-select-trigger>
            <mat-option *ngFor="let noBillingReason of noBillingReasons" [value]="noBillingReason">
                {{ noBillingReason.Name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="medium-width margin-right-small">
        <input type="text" matInput placeholder="Protocolo" formControlName="protocol" />
    </mat-form-field>

    <mat-form-field class="medium-width margin-right-small">
        <mat-select placeholder="Centros" formControlName="branchs" multiple>
            <mat-select-trigger>
                {{ f.branchs.value?.length > 0 ? f.branchs.value[0].Name : "" }}
                <span *ngIf="f.branchs.value?.length > 1" class="additional-selection">
          (+{{ f.branchs.value.length - 1 }}
          {{ f.branchs.value?.length === 2 ? "otro" : "otros" }})
        </span>
            </mat-select-trigger>
            <mat-option *ngFor="let branch of branchs" [value]="branch">
                {{ branch.Name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <div class="patient-filter-wrapper medium-width">
        <patient-autocomplete formControlName="patient"></patient-autocomplete>
    </div>


    <mat-checkbox class="margin-right-small" formControlName="atLeastOneInformed">Al menos un informe</mat-checkbox>
    <mat-checkbox formControlName="inSector">Ordenes en sector</mat-checkbox>

    <mat-checkbox class="margin-right-small" formControlName="orderByPatient"><span>Ordenar por paciente</span>
    </mat-checkbox>

    <mat-checkbox formControlName="onlyDerivantes"><span>Ver Entidades o Derivadores</span>
    </mat-checkbox>


</form>
